export enum PaymentMode {
  RID = 1,
  BonificoBancario = 2,
  MAV = 3,
  PAGOPA = 4
}
